import React from 'react';

import styled from 'styled-components';

import ImageWidget from './imageWidget';
import theme from './theme';

const Container = styled.div`
  width: 90%;
  max-width: 920px;
  margin: 0 auto;
  display: grid;
  position: relative;
  background: ${theme.backgroundColor};
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
  padding: 2.5rem 0;
  ${Styles.mobile} {
    padding: 1.5rem 0;
  }
  ${Styles.mobileSmall} {
    grid-template-columns: 1fr;
    grid-gap: 3.5rem;
  }
`;

const ImageColumn = styled.div`
  display: grid;
  grid-template-rows: auto auto;
`;

export default class DoubleImageWidget extends React.Component {
  render() {
    return (
      <Container>
        <ImageColumn>
          <ImageWidget {...this.props.image1} />
        </ImageColumn>
        <ImageColumn>
          <ImageWidget {...this.props.image2} />
        </ImageColumn>
      </Container>
    );
  }
}
